export { default } from './ProductCrossSale'



// WEBPACK FOOTER //
// ./src/App/components/ProductCrossSale/index.js